// Shared service catalogue + inline SVG icons, reused across Home, Search, and
// service registration. Category `value`s match the backend table/category names.

const svg = (children) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6"
       strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    {children}
  </svg>
);

export const ICONS = {
  cleaning: svg(<>
    <path d="M19 5l-2 2" /><path d="M13 7l4 4" />
    <path d="M11 9l-6 6a2.8 2.8 0 0 0 4 4l6-6" />
    <path d="M5 21h6" />
  </>),
  cook: svg(<>
    <path d="M7 3v5" /><path d="M11 3v5" /><path d="M9 8v13" />
    <path d="M17 3c-1.5 0-3 1.5-3 4s1 4 3 4v10" />
  </>),
  plumber: svg(<>
    <path d="M14 4l6 6" /><path d="M16 2l6 6-2 2-6-6z" />
    <path d="M14 8L5 17a3 3 0 1 0 2 2l9-9" />
  </>),
  electrician: svg(<>
    <path d="M13 2L4 14h7l-1 8 9-12h-7z" />
  </>),
  househelp: svg(<>
    <path d="M3 11l9-8 9 8" /><path d="M5 10v10h14V10" />
    <path d="M9 20v-6h6v6" />
  </>),
};

export const CATEGORIES = [
  { value: "cleaning", label: "Cleaning" },
  { value: "cook", label: "Cooking" },
  { value: "plumber", label: "Plumbing" },
  { value: "electrician", label: "Electrical" },
  { value: "househelp", label: "Househelp" },
];
